export default __webpack_public_path__ + "static/media/KOD0151-min.9a79d68d.webp";